import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import moment from 'moment';
import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useGlobal } from '@/utils/useGlobal';

interface Props {
    onClose: () => void;
    open: boolean;
}

const contactListIds = {
    ph: '420524278',
};

const Dialog: React.FC<Props> = ({ onClose, open }) => {
    const { t } = useLang('powerBank.C.dialog');
    const { locale } = getLocal();
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();

    const fields = useMemo(() => {
        const date = moment(systemTime).format('YYYY-MM-DD') as any;
        const PH_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: true },
            { type: 'multiple', id: '13972', value: [1], overwrite: false },
            { type: 'text', id: '13971', value: date, overwrite: false },
        ];
        switch (locale) {
            case 'ph':
                return [{ type: 'single', id: '11457', value: 1, overwrite: true }, ...PH_Fields];

            default:
                return [{ type: 'single', id: '11457', value: 1, overwrite: true }, ...PH_Fields];
        }
    }, [locale, systemTime]);

    // 邮件
    const termsHtml = useMemo(() => {
        switch (locale) {
            case 'ph':
                return `I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-${locale}/PrivacyPolicy.html" target="_blank">Privacy Policy</a> and <a href="https://${locale}.ecoflow.com/pages/terms-of-use" target="_blank">Terms of Use</a>.`;
            default:
                return undefined;
        }
    }, [locale]);

    if (!open) return null;
    return createPortal(
        <div className={style.comp}>
            <div className="mask"></div>
            <div className="body">
                <div className="close" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="black" fillOpacity="0.4" />
                        <path
                            d="M12.1262 6.46958C12.4191 6.17687 12.8939 6.17675 13.1867 6.46958C13.4794 6.76242 13.4794 7.23728 13.1867 7.53012L10.8879 9.82798L13.1867 12.1268C13.4796 12.4197 13.4796 12.8945 13.1867 13.1874C12.8938 13.4799 12.419 13.4801 12.1262 13.1874L9.82736 10.8885L7.52951 13.1874C7.23667 13.48 6.76181 13.48 6.46897 13.1874C6.17614 12.8945 6.17626 12.4197 6.46897 12.1268L8.76682 9.82798L6.46994 7.53012C6.17705 7.23723 6.17705 6.76247 6.46994 6.46958C6.76285 6.17687 7.23766 6.17675 7.53049 6.46958L9.82736 8.76743L12.1262 6.46958Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>

                <EcoEmail
                    contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.us]}
                    source="WEB_NEW_PRODUCT_SUB"
                    fields={fields}
                    termsHtml={termsHtml}
                    tipsObj={{
                        placeholder: t('placeholder'),
                        btnText: t('btnText'),
                    }}
                    needTerms
                />
            </div>
        </div>,
        document.body,
    );
};
export default Dialog;
